export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapEvents';
export const ENTITY_EDIT_ROUTE = 'events/management/edit';
export const ENTITY_TEMPLATE_EDIT_ROUTE = 'events/template/edit';
export const ENTITY_RESOURCE_PLAN_EDIT_ROUTE = 'events/resourcePlans/edit';
